import React from "react";
import "./index.css";

import Icon from "../Icon";

/* Helpers */
import { constructPreferenceTitle } from "../../helpers/candidate";

export default ({ jobs, updateUserProfileLookingFor, setIdealPosition, show, setCancelData }) => {

    return renderAddedPositions(jobs, updateUserProfileLookingFor, setIdealPosition, show, setCancelData);

}

const renderAddedPositions = (jobs, updateUserProfileLookingFor, setIdealPosition, show, setCancelData) => {

    return jobs.map((item, index) => {

        const onEdit = () => edit(updateUserProfileLookingFor, setIdealPosition, item, jobs, index, show, setCancelData);

        return(
            <div
                key={index}
                className="job-preference-container margin-top-20px job-preference-container--clickable"
                role="button"
                tabIndex={0}
                onClick={onEdit}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onEdit(); } }}
            >
                <div className="job-preference-actions-corner" onClick={(e) => e.stopPropagation()}>
                    <button type="button" className="job-preference-action-icon" aria-label="Edit" onClick={onEdit}>
                        <Icon name="edit" size={14} />
                    </button>
                    <button type="button" className="job-preference-action-icon job-preference-action-icon--danger" aria-label="Delete" onClick={() => del(updateUserProfileLookingFor, jobs, index)}>
                        <Icon name="trash" size={14} />
                    </button>
                </div>
                <div className="job-preference-title-container">
                    <p>{constructPreferenceTitle(index+1)}</p>
                </div>
                <div className="job-preference-chips">
                    {renderPreferenceChips(item)}
                </div>
            </div>
        );
    });

}

/**
 * Render the user's saved preference as a row of pill tags rather than the
 * old semicolon-separated sentence. Each meaningful field becomes its own
 * chip so the preference scans at a glance.
 */
const renderPreferenceChips = (preference) => {

    const chips = [];

    // Position(s)
    if (preference.position && preference.position.length > 0) {
        const first = preference.position[0]?.name;
        if (first) {
            const extras = preference.position.length - 1;
            chips.push({ key: "pos", label: extras > 0 ? `${first} +${extras}` : first });
        }
    }

    // Contract / job type
    if (preference.jobType && preference.jobType.length > 0) {
        if (preference.jobType.length >= 4) {
            chips.push({ key: "job", label: "Any contract" });
        } else {
            preference.jobType.forEach((t, i) => chips.push({ key: `job-${i}`, label: t }));
        }
    }

    // Yacht type
    if (preference.yachtType && preference.yachtType.length > 0) {
        preference.yachtType.forEach((t, i) => chips.push({ key: `type-${i}`, label: t }));
    }

    // Yacht size
    if (preference.noYachtSizePreference) {
        chips.push({ key: "size", label: "Any size" });
    } else {
        const min = preference.yachtSizeMin;
        const max = preference.yachtSizeMax;
        let sizeLabel = null;
        if (min && max) sizeLabel = `${min}–${max}m`;
        else if (min) sizeLabel = `${min}m+`;
        else if (max) sizeLabel = `Up to ${max}m`;
        if (sizeLabel) chips.push({ key: "size", label: sizeLabel });
    }

    return chips.map((c) => (
        <span key={c.key} className="job-preference-chip">{c.label}</span>
    ));

};

const edit = (updateUserProfileLookingFor, setIdealPosition, item, jobs, index, show, setCancelData) => {

    setCancelData(item);

    updateUserProfileLookingFor([{ propName: "desiredRoles", value: jobs.filter((_, idx) => idx !== index) }]);

    setIdealPosition([{ propName: "position", value: item.position }, { propName: "noYachtSizePreference", value: item.noYachtSizePreference }, { propName: "yachtSizeMin", value: item.yachtSizeMin }, { propName: "yachtSizeMax", value: item.yachtSizeMax }, { propName: "yachtType", value: item.yachtType }, { propName: "jobType", value: item.jobType }]);

    return show ? show() : "";

}

const del = (updateUserProfileLookingFor, jobs, index) => {

    return updateUserProfileLookingFor([{ propName: "desiredRoles", value: jobs.filter((_, idx) => idx !== index) }], true);

}
